var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { RouteFiller } from "../helpers/Helpers";
import { CollaborationServiceSetup } from "../Setup";
var EventController = /** @class */ (function () {
    function EventController() {
    }
    /*****************************************************************************************************
        * Is using route "api/event" and http method "POST" to call the back-end.
    
        * @param {EventUploadDto} ev
        * @returns {void}
    ******************************************************************************************************/
    EventController.PostEvent = function (data, onSuccess, onError, onProgress, mutex) {
        CollaborationServiceSetup.client.call({
            uri: RouteFiller("api/event", __assign({}, data)),
            method: "POST",
            onSuccess: onSuccess,
            onError: onError,
            onProgress: onProgress,
            mutex: mutex,
            data: data.ev
        });
    };
    /*****************************************************************************************************
        * Is using route "api/event/appChanged/{newAppType}/{groupId?}" and http method "POST" to call the back-end.
    
        * @param {string} newAppType
        * @param {string} groupId
        * @returns {void}
    ******************************************************************************************************/
    EventController.ApplicationChanged = function (data, onSuccess, onError, onProgress, mutex) {
        CollaborationServiceSetup.client.call({
            uri: RouteFiller("api/event/appChanged/{newAppType}/{groupId?}", __assign({}, data)),
            method: "POST",
            onSuccess: onSuccess,
            onError: onError,
            onProgress: onProgress,
            mutex: mutex,
        });
    };
    /*****************************************************************************************************
        * Is using route "api/event/{groupid}/{eventTypeStr}" and http method "GET" to call the back-end.
    
        * @param {string} groupid
        * @param {string} eventTypeStr
        * @returns {ExtendedDataCollection<EventDownloadDto, string>}
    ******************************************************************************************************/
    EventController.Get = function (data, onSuccess, onError, onProgress, mutex) {
        CollaborationServiceSetup.client.call({
            uri: RouteFiller("api/event/{groupid}/{eventTypeStr}", __assign({}, data)),
            method: "GET",
            onSuccess: onSuccess,
            onError: onError,
            onProgress: onProgress,
            mutex: mutex,
        });
    };
    return EventController;
}());
export { EventController };
/*
$PrintDebugInfo
*/ 
//# sourceMappingURL=EventController.js.map